import settings from '../config/settings';
import axios from './axios';

const { apiBaseURL } = settings;

export default class UserApi {
  static getUser() {
    return axios.get(`${apiBaseURL}/me`);
  }

  static getUsers() {
    return axios.get(`${apiBaseURL}/users`);
  }

  static updateUser(data) {
    return axios.patch(`${apiBaseURL}/users/${data.userId}`, data);
  }

  static invite(data) {
    return axios.post(`${apiBaseURL}/invite`, data);
  }

  static welcome(data) {
    return axios.post(`${apiBaseURL}/welcome`, data);
  }

  static changePassword(data) {
    return axios.post(`${apiBaseURL}/change-password`, data);
  }

  static resetPassword(data) {
    return axios.post(`${apiBaseURL}/reset-password`, data);
  }

  static setPassword(data) {
    return axios.post(`${apiBaseURL}/set-password`, data);
  }

  static join(data) {
    return axios.post(`${apiBaseURL}/join`, data);
  }
}



// WEBPACK FOOTER //
// ./src/api/UserApi.js